import React, { Component } from "react";
import moment from "moment";
import { Tabs, DatePicker } from "antd";
import enLocale from "antd/es/date-picker/locale/en_US";
import esLocale from "antd/es/date-picker/locale/es_ES";
import brLocale from "antd/es/date-picker/locale/pt_BR";
import { injectIntl } from "react-intl";

import IntlText from "../intlText/intl-text";

import "./CalendarPicker.scss";

const TabPane = Tabs.TabPane;

const DATEPICKER_LOCALE = {
  "en-US": enLocale,
  "es-ES": esLocale,
  "pt-BR": brLocale,
};

class CalendarPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "1",
      startDate: null,
      endDate: null,
    };
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (
      this.calendarRef &&
      !this.calendarRef.contains(event.target) &&
      event.target !== null
    ) {
      event.stopPropagation();
      this.props.onCalendarClickAway();
    }
  }

  onDatePickerChange(date) {
    if (this.state.activeTab === "1") {
      this.setState({
        startDate: date,
        activeTab: "2",
      });
    } else if (this.state.activeTab === "2") {
      this.setState(
        {
          endDate: date,
        },
        this.finishSelectPeriod.bind(this)
      );
    }
  }

  finishSelectPeriod() {
    this.props.onPeriodSelected &&
      this.props.onPeriodSelected(this.state.startDate, this.state.endDate);
  }

  onTabClick(key) {
    if (key !== this.state.activeTab) {
      this.setState({
        activeTab: key,
        startDate: null,
      });
    }
  }

  disabledDate(current) {
    return (
      current &&
      (current > moment().endOf("day") ||
        (this.state.startDate && current < this.state.startDate))
    );
  }

  render() {
    const startDate = <IntlText intlId="date.start" />;
    const endDate = <IntlText intlId="date.end" />;
    const cannonicalLocale = this.props.intl.formatMessage({
      id: "CANONICAL_LOCALE",
    });
    const datePickerLocale = DATEPICKER_LOCALE[cannonicalLocale];

    return (
      <div
        className="calendar-picker"
        ref={(node) => (this.calendarRef = node)}
      >
        <Tabs
          defaultActiveKey="1"
          activeKey={this.state.activeTab}
          onTabClick={this.onTabClick.bind(this)}
        >
          <TabPane tab={startDate} key="1" />

          <TabPane
            tab={endDate}
            key="2"
            disabled={this.state.activeTab === "1"}
          />
        </Tabs>

        <div ref={(node) => (this.datePickerContainerRef = node)} />

        <DatePicker
          locale={datePickerLocale}
          open
          dropdownClassName="calendar-date-picker"
          defaultValue={moment()}
          onChange={this.onDatePickerChange.bind(this)}
          showToday={false}
          getCalendarContainer={() => this.datePickerContainerRef}
          disabledDate={this.disabledDate.bind(this)}
        />
      </div>
    );
  }
}

export default injectIntl(CalendarPicker);
